import { createSelector } from 'reselect';
import { createSelectorDeep } from 'reselects/misc';
import _ from 'lodash';

export const getState = (state) => state.jobDetail;
export const getMe = (state) => state.me;

export const getDecisionModalMode = createSelectorDeep(
  getState,
  (state) => state.actionDecision.mode
);
export const getDecisionModalID = createSelectorDeep(getState, (state) => state.actionDecision.id);
export const getDecisionModalLoading = createSelectorDeep(
  getState,
  (state) => state.actionDecision.loading
);

export const getJobDetail = createSelectorDeep(getState, (detail) => detail);
const getJourney = createSelectorDeep(getJobDetail, (detail) => detail.data);
export const getJobDetailData = createSelectorDeep(getJourney, (journey) => journey);

export const getShipperOrderAssignmentId = createSelector(
  getState,
  (state) => state.shipperOrderAssignmentId
);
export const getJobDetailError = createSelector(getState, (state) => state.error);

export const getMinervaInfo = createSelector(getState, (state) => state.minervaInfo);

export const submodalOpened = createSelector(getState, (state) => state.submodal.name);

export const submodalParams = createSelector(getState, (state) => state.submodal.params);

const _getJourneySelectorProps = (_, journeyId, fields) => ({
  journeyId,
  fields,
});

const _getStopSelectorProps = (_, journeyId, stopId, fields) => ({
  journeyId,
  stopId,
  fields,
});

export const getJourneyFields = createSelector(
  getJourney,
  _getJourneySelectorProps,
  (journey, { fields }) => {
    return _.pick(journey, fields);
  }
);

export const getJourneyAdditionalDocumentsFields = createSelector(
  getJourney,
  _getJourneySelectorProps,
  (journey) => {
    return {
      additional_documents:
        journey &&
        journey.shipper_orders &&
        journey.shipper_orders.some(
          (shipper_order) =>
            shipper_order &&
            shipper_order.additional_documents &&
            shipper_order.additional_documents.length > 0
        ),
      need_to_be_printed:
        journey &&
        journey.shipper_orders &&
        journey.shipper_orders.some(
          (shipper_order) =>
            shipper_order &&
            shipper_order.additional_documents &&
            shipper_order.additional_documents.map(
              (additional_document) =>
                additional_document.need_to_be_printed &&
                additional_document.need_to_be_printed === true
            )
        ),
    };
  }
);

export const getShipperOrderIntoJourneyById = createSelector(
  getJourney,
  (_, shipperOrderId) => ({ shipperOrderId }),
  (journey, { shipperOrderId }) => {
    const shipperOrder =
      journey && (journey.shipper_orders || []).find((so) => so.id === shipperOrderId);

    return shipperOrder;
  }
);

export const getJourneyStopFields = createSelector(
  getJourney,
  _getStopSelectorProps,
  (journey, { stopId, fields }) => {
    return journey && journey.stops && _.pick(journey.stops[stopId], fields);
  }
);

export const getIsUnassigning = createSelector(getState, (state) => state.unassigning);

export const getIsPdfLoading = createSelector(getState, (state) => state.pdfLoading);

export const getSidebarTab = createSelector(getState, (state) => state.sidebarTab);
